(function() {
    var el = document.getElementById("calculated-monthly-rate");
    if (!el) return;

    var K = parseFloat(el.dataset.price);
    var ieff = parseFloat(el.dataset.interest) / 100;
    var A = 0;      // Anzahlung
    var n = 72;     // Laufzeit
    var RV = 0.5;   // Restwert 50%

    if (K <= 0) return;

    var D = K - A;
    var B = D * RV;
    var p = Math.pow(1 + ieff, 1 / 12) - 1;
    var PVB = B / Math.pow(1 + p, n);
    var P = D - PVB;
    var n1 = n - 1;

    var num = P * p * Math.pow(1 + p, n1);
    var den = Math.pow(1 + p, n1) - 1;
    if (den === 0) return;

    var CR = Math.ceil(num / den);
    el.textContent = CR.toLocaleString("de-DE");
})();